import { z } from 'zod';
import { MODULES, TENANT_TYPES } from '../enums';
import { ACTIONS, PERMISSION_MODULES } from '../permissions';

export const Id = z.string().min(1).max(64);
export const IsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Tarih YYYY-AA-GG biçiminde olmalı');
export const IsoDateTime = z.string().datetime({ offset: true });
export const Phone = z.string().regex(/^\+905\d{9}$/, 'Telefon +905xxxxxxxxx biçiminde olmalı');
export const LngLatSchema = z.tuple([z.number().min(-180).max(180), z.number().min(-90).max(90)]);

export const ErrorBody = z.object({
  error: z.object({ code: z.string(), message: z.string(), details: z.unknown().optional() }),
});
export type ErrorBody = z.infer<typeof ErrorBody>;

export const PageQuery = z.object({
  page: z.coerce.number().int().min(1).default(1),
  pageSize: z.coerce.number().int().min(1).max(200).default(20),
  q: z.string().max(120).optional(),
});
export type PageQuery = z.infer<typeof PageQuery>;

export function paged<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    items: z.array(item),
    total: z.number().int(),
    page: z.number().int(),
    pageSize: z.number().int(),
  });
}
export interface Paged<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

export const PermissionMatrixSchema = z.partialRecord(z.enum(PERMISSION_MODULES), z.array(z.enum(ACTIONS)));
export const FlagsSchema = z.record(z.enum(MODULES), z.boolean());
export const TenantTypeSchema = z.enum(TENANT_TYPES);
export const Ok = z.object({ ok: z.literal(true) });
